import {
  AverageLimit,
  AveragePlayerScore,
  AverageStat,
  BaseballAverageStatType,
  BasketballAverageStatType,
  Rarity,
  So5FixtureEvent,
  So5LeaderboardSeasonality,
} from '__generated__/globalTypes';
import { AlgoliaCardIndexesName } from 'contexts/config';

import { TotalAveragePlayerScore } from './averagePlayerScore';

export enum PlayerSearchViewAttributes {
  AVERAGE_PLAYER_SCORE = 'AVERAGE_PLAYER_SCORE',
  AVERAGE_LIMIT = 'AVERAGE_LIMIT',
  BREAKDOWN = 'BREAKDOWN',
  PROJECTION = 'PROJECTION',
  STATS = 'STATS',
  SEASONALITY = 'SEASONALITY',
  RARITY = 'RARITY',
  STATS_DISPLAY = 'STATS_DISPLAY',
  SORT = 'SORT',
  ONBOARDING = 'ONBOARDING',
  SHOW_APPEARANCES = 'SHOW_APPEARANCES',
  CARDS_SORT = 'MARKET_DRAWER_SORT',
  STATS_MODE = 'STATS_MODE',
}

export enum StatsOnboarding {
  INIT = 'INIT',
  ADVANCED_VIEW = 'ADVANCED_VIEW',
  SORT_BY_CLICKING = 'SORT_BY_CLICKING',
  COMBINE_SORTS = 'COMBINE_SORTS',
  FILTERS = 'FILTERS',
  ONBOARDED = 'ONBOARDED',
}

export enum StatsDisplay {
  PER_MATCH = 'PER_MATCH',
  TOTAL = 'TOTAL',
}

export type StatsRarity =
  | Rarity.limited
  | Rarity.rare
  | Rarity.super_rare
  | Rarity.unique;

export enum StatsMode {
  PITCHING = 'PITCHING',
  HITTING = 'HITTING',
  DEFAULT = 'DEFAULT',
}

export type PlayerSearchView = {
  [PlayerSearchViewAttributes.AVERAGE_PLAYER_SCORE]: TotalAveragePlayerScore[];
  [PlayerSearchViewAttributes.BREAKDOWN]: AveragePlayerScore[];
  [PlayerSearchViewAttributes.PROJECTION]: So5FixtureEvent[];
  [PlayerSearchViewAttributes.STATS]:
    | AverageStat[]
    | BasketballAverageStatType[]
    | BaseballAverageStatType[];
  [PlayerSearchViewAttributes.STATS_MODE]: StatsMode;
  [PlayerSearchViewAttributes.AVERAGE_LIMIT]: AverageLimit;
  [PlayerSearchViewAttributes.RARITY]: StatsRarity;
  [PlayerSearchViewAttributes.SEASONALITY]: So5LeaderboardSeasonality;
  [PlayerSearchViewAttributes.STATS_DISPLAY]: StatsDisplay;
  [PlayerSearchViewAttributes.SORT]: string;
  [PlayerSearchViewAttributes.SHOW_APPEARANCES]: boolean;
  [PlayerSearchViewAttributes.ONBOARDING]: StatsOnboarding;
  [PlayerSearchViewAttributes.CARDS_SORT]: AlgoliaCardIndexesName;
};
